import * as z from "zod";
import {
  VOICE_NOTE_MAX_AUDIO_BYTES,
  VOICE_NOTE_MAX_DURATION_MS,
  voiceNoteAudioMimeTypes,
  voiceNoteLocaleSchema,
} from "./voice-note";

const MAX_BASE64_LENGTH = Math.ceil(VOICE_NOTE_MAX_AUDIO_BYTES / 3) * 4;

export const transcribeProcessingNote = {
  name: "transcribeProcessingNote" as const,
  input: z.object({
    audioData: z
      .string()
      .min(1)
      .max(MAX_BASE64_LENGTH)
      .describe("Base64-encoded audio, without a data: URL prefix"),
    mimeType: z.enum(voiceNoteAudioMimeTypes),
    durationMs: z
      .number()
      .min(0)
      .max(VOICE_NOTE_MAX_DURATION_MS * 2)
      .describe("Recording length; background tabs can overshoot the limit"),
    sourceLocale: voiceNoteLocaleSchema,
    targetLocale: voiceNoteLocaleSchema,
  }),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal("transcribed"),
      originalText: z.string(),
      translatedText: z
        .string()
        .nullable()
        .describe("Null when translation failed; the caller can retry"),
    }),
    z.object({ status: z.literal("no_speech") }),
    z.object({
      status: z.literal("no_note"),
      originalText: z
        .string()
        .describe(
          "What was heard; the model found no note about the item in it",
        ),
    }),
  ]),
};
